var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"backImg"},[_c('div',{staticClass:"ybh",on:{"click":function($event){return _vm.$router.push(`save`)}}},[_vm._v("\n      进入\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }